<template>
  <div class='institutional-qnr-section-view view is-flex gap-2 py-6 p-6'>
    <QnrSectionNav :sections='sections' :n='n'/>

    <div class='is-flex-col' :style="{maxWidth: !isValuesWizard ? '40rem' : '65rem'}">
      <header class='mb-6'  v-if="!isValuesWizard">
        <h1 class='title is-2 is-extra-bold mb-6'>{{ section.name }}</h1>

        <p
          v-if='adminOnly && !context.prospect_is_admin'
          class='notification is-warning'>
          {{ section.admin_desc || defaultAdminDesc }}
        </p>
        <p class='subtitle is-6 has-text-grey is-heavy'>{{ section.desc }}</p>
      </header>
      <div class='is-flex-col gap-3 mt-3' v-if="!isValuesWizard">
        <Question
          v-for='question in section.questions'
          :id="question.id"
          :question='question'
          :context='context'
          :adminResponses='adminResponses'
          :currentQuestionId='currentQuestionId'
          @moveToNext="moveTo(question.id + 1)"
          @moveToPrevious="moveTo(question.id - 1)"
          @moveTo="moveTo(question.id)"
          :isLast="question.id == section.questions.length"
          :key='question.id'
          @answered='(answer) => onQuestionAnswered(question, answer)'
          />
      </div>
      <div v-else class="ml-6">
        <ClientPreferences :embedded="true" @stepNext="moveToNextSection()" :context='context'/>
      </div>

      <footer class='is-flex mt-6' v-if="!isValuesWizard">
        <router-link :to='url' class='is-flex-grow-1' v-if='nextSection'>
          <button class='button is-primary'>Next Section</button>
        </router-link>

        <button class='button is-primary' @click='finish()' v-else>
          Finish Questionnaire
        </button>

        <div v-if='nextSection' class="is-justify-content-flex-end is-size-7 bold" style="{color: this.$root.$data.COLORS.gray[4]}">
          <div>Next section</div>
          <div>{{ nextSectionName }}</div>
        </div>
      </footer>
    </div>
  </div>
</template>


<script>
import QnrSectionNav from '../../components/institutional_questionnaire/QnrSectionNav.vue';
import Question from '../../components/institutional_questionnaire/Question.vue';
import ClientPreferences from '@frontend/dash3/js/widgets/ClientPreferences.vue';
import { postQuestionnaireResponses } from '@frontend/api/questionnaireApi';


export default {
  name: 'institutional-qnr-section-view',
  components: { QnrSectionNav, Question, ClientPreferences },
  props: ['context', 'sections', 'adminResponses'],
  data() {
    return {
      currentQuestionId: 1,
      responses: {
        answers: {},
        provides_values: false,
      },
      defaultAdminDesc: 'This section can only be edited by your group admin. It is shown for informational purposes only.',
    };
  },
  beforeCreate() {},
  created() {
    this.debouncedPostResponses = _.debounce(this.postResponses, 500);
  },
  mounted() {
    console.log('Mounted');
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    csrf() {
      return this.$root.$data.csrfToken;
    },
    n() {
      return parseInt(this.$route.params.section);
    },
    section() {
      return this.sections ? this.sections[this.n - 1] : {};
    },
    nextSection() {
      return this.sections ? this.sections[this.n] : null;
    },
    nextSectionName() {
      if (!this.nextSection) return null;
      return this.nextSection.name;
    },
    url() {
      if (this.nextSection) {
        return {
          name: 'institutional-qnr-section',
          params: { section: this.n + 1 },
        };
      }

      return { name: 'institutional-qnr-thanks' };
    },
    adminOnly() {
      // Check if entire section is admin only
      if (!this.section?.questions) return null;
      const count = this.section.questions.filter(q => !q.admin_only).length;
      const total = this.section.questions.length;
      return count === 0 && total > 0;
    },
    isValuesWizard() {
      if (!this.section) return false;
      return this.section.name === 'Select Causes';
    },
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    onQuestionAnswered(question, answer) {
      this.responses.answers[question.slug] = answer;
      this.debouncedPostResponses();
    },
    async postResponses(notify=false) {
      const res = await postQuestionnaireResponses('inst-qnr-v1', { ...this.responses, notify }, this.csrf);
      console.log(res);
    },
    moveToNextSection() {
      this.$router.push({
        name: 'institutional-qnr-section',
        params: { section: this.n + 1 },
        query: this.$route.query
      }).catch(() => {});
    },
    moveTo(idToMoveTo) {
      this.currentQuestionId = idToMoveTo;
      const el = document.getElementById(this.currentQuestionId);
      el && el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    finish() {
      this.postResponses(true);
      this.$router.push(this.url).catch(() => {});
    },
  },
};
</script>


<style scoped>
.main > * {
  max-width: 40rem;
}
</style>
